<template>
    <div>
        <div class="tool-bar mb10">
            <el-button 
                type="primary" 
                v-if="pageFuncNames.includes('add_group')"  
                size="mini" class="mr10"
                @click="()=>addModal()"
             >
                添加部门
             </el-button>
              <el-button 
                type="primary" 
                v-if="pageFuncNames.includes('edit_production_capacity')"  
                size="mini" class="mr10"
                plain
                @click="()=>editCapacity(multipleSelection)"
             >
                批量修改
             </el-button>
        </div>
        <div class="data-list">
            <jt-table
                v-loading="dataLoading"
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="部门"
                    align="left"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="production_capacity"
                    label="产能"
                    align="center"
                    width="180"
                >
                    <template slot-scope="{ row }">
                        {{row.production_capacity}}
                        <span @click="()=>editCapacity([row])" v-if="pageFuncNames.includes('edit_production_capacity')" class="text-color-primary pointer el-icon-edit-outline ver-middle ml6 font16px text-bold"></span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="p_group_name"
                    label="上级部门"
                    align="left"
                    min-width="150"
                    show-overflow-tooltip
                 />
                <el-table-column
                    prop="edit_name"
                    label="最新修改人"
                    align="center"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="mtime"
                    label="最新修改时间"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.mtime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                     v-if="pageFuncNames.includes('history_modify_list')"
                    label="历史修改记录"
                    align="center"
                    width="100">
                     <template slot-scope="{ row }">
                        <el-button type="text" @click="()=>handleHistory(row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    width="100">
                    <template slot-scope="{ row }">
                        <div class="tac">
                          
                             <el-button 
                                v-if="pageFuncNames.includes('delete')" 
                                type="text"
                                
                                class="text-color-primary mr10"
                                @click="()=>handleDelete(row)"
                            >
                                <span style="color: #FF4949;">删除</span>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </jt-table>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import { addDepartmentModal,editCapacityModal,capacityHistoryModal } from '../modal';
    export default {
        name: "CapacityInputList",
        props:{
            pageFunc:Array,
        },
        data(){
            return {
                dataLoading:false,
                dataList:[],
                multipleSelection:[]
            }
        },
        computed:{
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            this.getList();
        },
        methods:{
            handleHistory(row){
                capacityHistoryModal({
                    props: {
                        data:row
                    },
                })
            },
            editCapacity(list){
                const onSubmit = async ()=> {
                    vm.close();
                    this.getList();
                }
                const { vm } = editCapacityModal({
                    props: {
                        list
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
             handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            async handleDelete(row){
                this.$confirm(`确认删除【${row.name}】吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const params ={
                            id: row.id,
                        };
                        await API.deleteProductionCapacityConfigInfo(params);
                        this.$message.success('操作成功');
                        this.getList();
                    } catch (error) {
                        this.$message.error(error.info);
                    }
                });
            },
            addModal() {
                const onSubmit = async (formData)=> {
                    vm.close();
                    this.getList();
                }
                const { vm } = addDepartmentModal({
                    cbs: {
                        onSubmit
                    }
                })
            },
            async getList() {
                try {
                    this.dataLoading = true;
                    const { data } = await API.getProductionCapacityConfigList();
                    this.dataList = data
                } catch (error) {
                    this.$message.error(error.info);
                }finally {
                    this.dataLoading = false;
                }
            }
        },
    }
</script>

<style scoped>
.word-break {
    word-break:break-word;
}
</style>
